import {
  DatabaseService,
  StockCheck,
  StockCheckData,
  StockCheckRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getStockCheckRepository(
  databaseService: DatabaseService,
): StockCheckRepository {
  return getGenericRepository<StockCheck, StockCheckData>(
    () => DatabaseCollection.STOCK_CHECKS,
    databaseService,
  );
}
